import classNames from 'classnames';
import { PropTypes } from 'prop-types';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Field } from 'redux-form';
import { fieldRequired, requiredInput } from '../../../core/formValidation';

export const InventoryTypeFields = ({ fields }) => {
  useEffect(() => {
    fields.push();
  }, []);
  const intl = useIntl();
  return (
    <div className="inline-add-item-button">
      {fields.map((type, index) => (
        <div key={index} className="field-row">
          <div className="field-row-heading">
            <p>{`Type #${index + 1}`}</p>
            {index > 0 && (
              <button
                className={classNames('close', 'no-float', 'multi-form-delete')}
                onClick={() => {
                  fields.remove(index);
                }}
              >
                <i className="icon icon-squared-cross" />
              </button>
            )}
          </div>
          <div className="form-group">
            <Field
              className="form-control row-padding"
              name={`${type}.name`}
              id="name"
              component={requiredInput}
              type="text"
              aria-describedby="descriptionHelp"
              placeholder="Name"
              validate={[fieldRequired]}
            />
          </div>
        </div>
      ))}
      <button
        className={classNames('button')}
        data-testid="addTypeButton"
        onClick={() => {
          fields.push();
        }}
      >
        {intl.formatMessage({ id: 'addInventoryType' })}
      </button>
    </div>
  );
};

InventoryTypeFields.propTypes = {
  fields: PropTypes.shape({}),
};

export default InventoryTypeFields;
